import * as React from 'react';

class Annotation extends React.Component<{}> {
    public render() {
        return (
            <React.Fragment>
                <p>MAF Annotation Page is under construction.</p>
            </React.Fragment>
        );
    }
}

export default Annotation;
